import Header from "components/Headers/Header";
import Tabs from "components/Tabe";
import TableComponent from "components/TableComponent";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { Button, Card, Container, Spinner } from "reactstrap";
import { getVoteGetterBadgeEarnings } from "store/actions/AthleteEarningsAction";
import { getPizzaMoneyAthleteEarnings } from "store/actions/AthleteEarningsAction";
import { getTalkingBadgeEarnings } from "store/actions/AthleteEarningsAction";
import { getEndorsementBadgeEarnings } from "store/actions/AthleteEarningsAction";
import { getMomentoEarnings } from "store/actions/AthleteEarningsAction";
import { getChatEarnings } from "store/actions/AthleteEarningsAction";
import { getHonorBadgeEarnings } from "store/actions/AthleteEarningsAction";
import { getAthleteTalentContestEarnings } from "store/actions/AthleteEarningsAction";
import { getGroupChatEarnings } from "store/actions/AthleteEarningsAction";
import { getSeasonalBadgeEarnings } from "store/actions/AthleteEarningsAction";
import { getTotalEarningsBySection } from "store/actions/AthleteEarningsAction";
import { getSportBadgeEarnings } from "store/actions/AthleteEarningsAction";

const AthleteEarning = () => {
  let dispatch = useDispatch();
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("badge");
  const [loader, setLoader] = useState({
    loadMore: false,
    data: false,
  });
  const earnings = useSelector((state) => state.athleteEarnings);

  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getSportBadgeEarnings(id, "", () => {
        // setActiveTab("badge");
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
    dispatch(
      getTotalEarningsBySection({
        id: id,
        serviceType: "sport badges",
        key: "totalSportBadgeEarning",
      })
    );
  }, []);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };
  const [activeTabBadges, setActiveTabBadges] = useState("sport-badge");
  const toggleTabBadges = (tab) => {
    if (activeTabBadges !== tab) {
      setActiveTabBadges(tab);
    }
  };
  const [activeTabChat, setActiveTabChat] = useState("single-chat");
  const toggleTabChat = (tab) => {
    if (activeTabChat !== tab) {
      setActiveTabChat(tab);
    }
  };

  const handleSportBadge = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getSportBadgeEarnings(id, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };
  const loadMoreSportBadge = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getSportBadgeEarnings(id, earnings.lastDocumentSportBadge, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };
  const handleSeasonalBadge = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getSeasonalBadgeEarnings(id, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
    dispatch(
      getTotalEarningsBySection({
        id: id,
        serviceType: "seasonal badges",
        key: "totalSeasonalBadgeEarning",
      })
    );
  };
  const loadMoreSeasonalBadge = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getSeasonalBadgeEarnings(id, earnings.lastDocumentSeasonalBadge, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };

  const handleEndorsementBadge = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getEndorsementBadgeEarnings(id, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
    dispatch(
      getTotalEarningsBySection({
        id: id,
        serviceType: "endorsement",
        key: "totalEndorsementBadgeEarning",
      })
    );
  };

  const loadMoreEndorsementBadge = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getEndorsementBadgeEarnings(
        id,
        earnings.lastDocumentEndorsementBadge,
        () => {
          setLoader((prev) => ({
            ...prev,
            loadMore: false,
          }));
        }
      )
    );
  };

  const handleTalkingBadge = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getTalkingBadgeEarnings(id, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
    dispatch(
      getTotalEarningsBySection({
        id: id,
        serviceType: "talking badges",
        key: "totalTalkingBadgeEarning",
      })
    );
  };
  const loadMoreTalkingBadge = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getTalkingBadgeEarnings(id, earnings.lastDocumentTalkingBadge, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };
  const handleHonorBadge = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getHonorBadgeEarnings(id, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
    dispatch(
      getTotalEarningsBySection({
        id: id,
        serviceType: "honor badges",
        key: "totalHonorBadgeEarning",
      })
    );
  };
  const loadMoreHonorBadge = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getHonorBadgeEarnings(id, earnings.lastDocumentHonorBadge, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };
  const handleVoteGetterBadge = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getVoteGetterBadgeEarnings(id, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
    dispatch(
      getTotalEarningsBySection({
        id: id,
        serviceType: "vote getter badges",
        key: "totalVoteGetterBadgeEarning",
      })
    );
  };
  const loadMoreVoteGetterBadge = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getVoteGetterBadgeEarnings(
        id,
        earnings.lastDocumentVoteGetterBadge,
        () => {
          setLoader((prev) => ({
            ...prev,
            loadMore: false,
          }));
        }
      )
    );
  };

  const handleMomento = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getMomentoEarnings(id, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
    dispatch(
      getTotalEarningsBySection({
        id: id,
        serviceType: "momento",
        key: "totalMomentoEarning",
      })
    );
  };
  const loadMoreMomento = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getMomentoEarnings(id, earnings.lastDocumentMomento, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };

  const handleChatEarning = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getChatEarnings(id, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
    dispatch(
      getTotalEarningsBySection({
        id: id,
        serviceType: "single chat",
        key: "totalSingleChatEarning",
      })
    );
  };
  const loadMoreSingleChat = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getChatEarnings(id, earnings.lastDocumentSingleChat, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };

  const handleGroupChatEarning = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getGroupChatEarnings(id, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
    dispatch(
      getTotalEarningsBySection({
        id: id,
        serviceType: "group chat",
        key: "totalGroupChatEarning",
      })
    );
  };
  const loadMoreGroupChat = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getGroupChatEarnings(id, earnings.lastDocumentGroupChat, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };
  const handleContestEarning = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getAthleteTalentContestEarnings(id, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
    dispatch(
      getTotalEarningsBySection({
        id: id,
        serviceType: "ambassador contest",
        key: "totalContestEarning",
      })
    );
  };

  const loadMoreContest = () => {
    dispatch(
      getAthleteTalentContestEarnings(
        id,
        earnings.lastDocumentContest,
        () => {}
      )
    );
  };
  const handlePizzaMoneyEarning = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getPizzaMoneyAthleteEarnings(id, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
    dispatch(
      getTotalEarningsBySection({
        id: id,
        serviceType: "pizza-money",
        key: "totalPizzaMoneyEarning",
      })
    );
  };

  const loadMorePizzaMoney = () => {
    dispatch(
      getAthleteTalentContestEarnings(
        id,
        earnings.lastDocumentPizzaMoney,
        () => {}
      )
    );
  };
  //Table Data

  const column = ["Amount", "Fan Name", "Date"];
  const columnPizzaMoney = [
    "Amount",
    "Admin Amount",
    "GW Amount",
    "Athlete Amount",
    "Date",
  ];

  const keyMaps = {
    Amount: "Amount",
    "Fan Name": "fanName",
    Date: "Date",
  };
  const keyMapsPizzaMoney = {
    Amount: "Amount",
    "Admin Amount": "AdminAmount",
    "GW Amount": "GWAmount",
    "Athlete Amount": "AthleteAmount",
    Date: "Date",
  };

  const formatPizzaMoneyData = (data) => {
    return data.map((item) => ({
      ...item,
      Amount: item.amount ? item.amount.toFixed(2) : "0.00",
      AdminAmount: item.adminAmount ? item.adminAmount.toFixed(2) : "0.00",
      GWAmount: item.gwAmount ? item.gwAmount.toFixed(2) : "0.00",
      AthleteAmount: item.athleteAmount
        ? item.athleteAmount.toFixed(2)
        : "0.00",
      Date: moment.unix(item?.createdAt.seconds).format("MM-DD-YYYY"),
    }));
  };

  const formatEarningsData = (data) => {
    return data.map((item) => ({
      ...item,
      Amount: item.Amount.toFixed(2),
      Date: moment.unix(item?.created_at.seconds).format("MM-DD-YYYY"),
    }));
  };

  //Tabs

  const badgesTabes = [
    {
      id: "sport-badge",
      title: "Sport Badge",
      content: (
        <>
          {loader.data ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <h1 className="earning-title text-center text-sm-left">
                Total Sport Badge's Earning:{" "}
                {earnings.totalSportBadgeEarning
                  ? `${earnings.totalSportBadgeEarning}$`
                  : "0"}
              </h1>
              <Card className="p-2">
                <TableComponent
                  columns={column}
                  data={formatEarningsData(earnings.sportBadge)}
                  keyMap={keyMaps}
                />
                {earnings.sportBadge.length > 9 && (
                  <div className="text-center">
                    <Button
                      color="primary"
                      onClick={loadMoreSportBadge}
                      disabled={loader.loadMore || !earnings.hasMoreSportBadge}
                    >
                      {loader.loadMore ? <Spinner size="sm" /> : " Load more"}
                    </Button>
                  </div>
                )}
              </Card>
            </>
          )}
        </>
      ),
      onClick: handleSportBadge,
    },
    {
      id: "seasonal-badge",
      title: "Seasonal Badge",
      content: (
        <>
          {loader.data ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <h1 className="earning-title text-center text-sm-left">
                Total Seasonal Badge's Earning:{" "}
                {earnings.totalSeasonalBadgeEarning
                  ? `${earnings.totalSeasonalBadgeEarning}$`
                  : "0"}
              </h1>
              <Card className="p-2">
                <TableComponent
                  columns={column}
                  data={formatEarningsData(earnings.seasonalBadge)}
                  keyMap={keyMaps}
                />
                {earnings.seasonalBadge.length > 9 && (
                  <div className="text-center">
                    <Button
                      color="primary"
                      onClick={loadMoreSeasonalBadge}
                      disabled={
                        loader.loadMore || !earnings.hasMoreSeasonalBadge
                      }
                    >
                      {loader.loadMore ? <Spinner size="sm" /> : " Load more"}
                    </Button>
                  </div>
                )}
              </Card>
            </>
          )}
        </>
      ),
      onClick: handleSeasonalBadge,
    },
    {
      id: "endorsement-badge",
      title: "Endorsement Badge",
      content: (
        <>
          {loader.data ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <h1 className="earning-title text-center text-sm-left">
                Total Endorsement Badge's Earning:{" "}
                {earnings.totalEndorsementBadgeEarning
                  ? `${earnings.totalEndorsementBadgeEarning}$`
                  : "0"}
              </h1>
              <Card className="p-2">
                <TableComponent
                  columns={column}
                  data={formatEarningsData(earnings.endorsementBadge)}
                  keyMap={keyMaps}
                />
                {earnings.endorsementBadge.length > 9 && (
                  <div className="text-center">
                    <Button
                      color="primary"
                      onClick={loadMoreEndorsementBadge}
                      disabled={
                        loader.loadMore || !earnings.hasMoreEndorsementBadge
                      }
                    >
                      {loader.loadMore ? <Spinner size="sm" /> : " Load more"}
                    </Button>
                  </div>
                )}
              </Card>
            </>
          )}
        </>
      ),
      onClick: handleEndorsementBadge,
    },
    {
      id: "talking-badge",
      title: "Talking Badge",
      content: (
        <>
          {loader.data ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <h1 className="earning-title text-center text-sm-left">
                Total Talking Badge's Earning:{" "}
                {earnings.totalTalkingBadgeEarning
                  ? `${earnings.totalTalkingBadgeEarning}$`
                  : "0"}
              </h1>
              <Card className="p-2">
                <TableComponent
                  columns={column}
                  data={formatEarningsData(earnings.talkingBadge)}
                  keyMap={keyMaps}
                />
                {earnings.talkingBadge.length > 9 && (
                  <div className="text-center">
                    <Button
                      color="primary"
                      onClick={loadMoreTalkingBadge}
                      disabled={
                        loader.loadMore || !earnings.hasMoreTalkingBadge
                      }
                    >
                      {loader.loadMore ? <Spinner size="sm" /> : " Load more"}
                    </Button>
                  </div>
                )}
              </Card>
            </>
          )}
        </>
      ),
      onClick: handleTalkingBadge,
    },
    {
      id: "honor-badge",
      title: "Honor Badge",
      content: (
        <>
          {loader.data ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <h1 className="earning-title text-center text-sm-left">
                Total Honor Badge's Earning:{" "}
                {earnings.totalHonorBadgeEarning
                  ? `${earnings.totalHonorBadgeEarning}$`
                  : "0"}
              </h1>
              <Card className="p-2">
                <TableComponent
                  columns={column}
                  data={formatEarningsData(earnings.honorBadge)}
                  keyMap={keyMaps}
                />
                {earnings.honorBadge.length > 9 && (
                  <div className="text-center">
                    <Button
                      color="primary"
                      onClick={loadMoreHonorBadge}
                      disabled={loader.loadMore || !earnings.hasMoreHonorBadge}
                    >
                      {loader.loadMore ? <Spinner size="sm" /> : " Load more"}
                    </Button>
                  </div>
                )}
              </Card>
            </>
          )}
        </>
      ),
      onClick: handleHonorBadge,
    },
    {
      id: "vote-getter-badge",
      title: "Vote Getter Badge",
      content: (
        <>
          {loader.data ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <h1 className="earning-title text-center text-sm-left">
                Total Vote Getter Badge's Earning:{" "}
                {earnings.totalVoteGetterBadgeEarning
                  ? `${earnings.totalVoteGetterBadgeEarning}$`
                  : "0"}
              </h1>
              <Card className="p-2">
                <TableComponent
                  columns={column}
                  data={formatEarningsData(earnings.voteGetterBadge)}
                  keyMap={keyMaps}
                />
                {earnings.voteGetterBadge.length > 9 && (
                  <div className="text-center">
                    <Button
                      color="primary"
                      onClick={loadMoreVoteGetterBadge}
                      disabled={
                        loader.loadMore || !earnings.hasMoreVoteGetterBadge
                      }
                    >
                      {loader.loadMore ? <Spinner size="sm" /> : " Load more"}
                    </Button>
                  </div>
                )}
              </Card>
            </>
          )}
        </>
      ),
      onClick: handleVoteGetterBadge,
    },
  ];

  const chatTabes = [
    {
      id: "single-chat",
      title: "Chat Earnings",
      content: (
        <>
          {loader.data ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <h1 className="earning-title text-center text-sm-left">
                Total Single Chat Earning:{" "}
                {earnings.totalSingleChatEarning
                  ? `${earnings.totalSingleChatEarning}$`
                  : "0"}
              </h1>
              <Card className="p-2">
                <TableComponent
                  columns={column}
                  data={formatEarningsData(earnings.singleChat)}
                  keyMap={keyMaps}
                />
                {earnings.singleChat.length > 9 && (
                  <div className="text-center">
                    <Button
                      color="primary"
                      onClick={loadMoreSingleChat}
                      disabled={loader.loadMore || !earnings.hasMoreSingleChat}
                    >
                      {loader.loadMore ? <Spinner size="sm" /> : " Load more"}
                    </Button>
                  </div>
                )}
              </Card>
            </>
          )}
        </>
      ),
      onClick: handleChatEarning,
    },
    {
      id: "group_chat",
      title: "Group Chat Earnings",
      content: (
        <>
          {loader.data ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <h1 className="earning-title text-center text-sm-left">
                Total Group Chat Earning:{" "}
                {earnings.totalGroupChatEarning
                  ? `${earnings.totalGroupChatEarning}$`
                  : "0"}
              </h1>
              <Card className="p-2">
                <TableComponent
                  columns={column}
                  data={formatEarningsData(earnings.groupChat)}
                  keyMap={keyMaps}
                />
                {earnings.groupChat.length > 9 && (
                  <div className="text-center">
                    <Button
                      color="primary"
                      onClick={loadMoreGroupChat}
                      disabled={loader.loadMore || !earnings.hasMoreGroupChat}
                    >
                      {loader.loadMore ? <Spinner size="sm" /> : " Load more"}
                    </Button>
                  </div>
                )}
              </Card>
            </>
          )}
        </>
      ),
      onClick: handleGroupChatEarning,
    },
  ];

  const tabs = [
    {
      id: "badge",
      title: "Badge",
      content: (
        <>
          <Tabs
            activeTab={activeTabBadges}
            toggleTab={toggleTabBadges}
            tabs={badgesTabes}
          />
        </>
      ),
      onClick: () => {},
    },
    {
      id: "chat",
      title: "Chat",
      content: (
        <>
          <Tabs
            activeTab={activeTabChat}
            toggleTab={toggleTabChat}
            tabs={chatTabes}
          />
        </>
      ),
      onClick: () => {},
    },
    {
      id: "momento",
      title: "Momento",
      content: (
        <>
          {loader.data ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <h1 className="earning-title text-center text-sm-left">
                Total Momento Earning:{" "}
                {earnings.totalMomentoEarning
                  ? `${earnings.totalMomentoEarning}$`
                  : "0"}
              </h1>
              <Card className="p-2">
                <TableComponent
                  columns={column}
                  data={formatEarningsData(earnings.momento)}
                  keyMap={keyMaps}
                />
                {earnings.momento.length > 9 && (
                  <div className="text-center">
                    <Button
                      color="primary"
                      onClick={loadMoreMomento}
                      disabled={loader.loadMore || !earnings.hasMoreMomento}
                    >
                      {loader.loadMore ? <Spinner size="sm" /> : " Load more"}
                    </Button>
                  </div>
                )}
              </Card>
            </>
          )}
        </>
      ),
      onClick: handleMomento,
    },
    {
      id: "contest",
      title: "Athlete talent contest",
      content: (
        <>
          {loader.data ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <h1 className="earning-title text-center text-sm-left">
                Total Athlete Talent Contest earning:{" "}
                {earnings.totalContestEarning
                  ? `${earnings.totalContestEarning}$`
                  : "0"}
              </h1>
              <Card className="p-2">
                <TableComponent
                  columns={column}
                  data={formatEarningsData(earnings.contest)}
                  keyMap={keyMaps}
                />
                {earnings.contest.length > 9 && (
                  <div className="text-center">
                    <Button
                      color="primary"
                      onClick={loadMoreContest}
                      disabled={loader.loadMore || !earnings.hasMoreContest}
                    >
                      {loader.loadMore ? <Spinner size="sm" /> : " Load more"}
                    </Button>
                  </div>
                )}
              </Card>
            </>
          )}
        </>
      ),
      onClick: handleContestEarning,
    },
    {
      id: "pizza-money",
      title: "Pizza Money",
      content: (
        <>
          {loader.data ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <h1 className="earning-title text-center text-sm-left">
                Total Pizza Money earning:{" "}
                {earnings.totalPizzaMoneyEarning
                  ? `${earnings.totalPizzaMoneyEarning}$`
                  : "0"}
              </h1>
              <Card className="p-2">
                <TableComponent
                  columns={columnPizzaMoney}
                  data={formatPizzaMoneyData(earnings.pizzaMoney)}
                  keyMap={keyMapsPizzaMoney}
                />
                {earnings.pizzaMoney.length > 5 && (
                  <div className="text-center">
                    <Button
                      color="primary"
                      onClick={loadMorePizzaMoney}
                      disabled={loader.loadMore || !earnings.hasMorePizzaMoney}
                    >
                      {loader.loadMore ? <Spinner size="sm" /> : " Load more"}
                    </Button>
                  </div>
                )}
              </Card>
            </>
          )}
        </>
      ),
      onClick: handlePizzaMoneyEarning,
    },
  ];

  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        <div className="text-right mb-4">
          <Link to={`/public/annual-earning/${id}`} className="btn btn-primary">
            Annual Earning
          </Link>
        </div>
        <Card className="pb-2">
          <Tabs activeTab={activeTab} toggleTab={toggleTab} tabs={tabs} />
        </Card>
      </Container>
    </>
  );
};

export default AthleteEarning;
